module.exports = __webpack_public_path__ + "c77332f603c38a787040215d965ac5c4.woff2";